import { Dispatch, SetStateAction } from 'react';
import { INode, ISelectedMatch, ISetMatchDataLoading, ITerm } from '../Types/BulkPricingTypes';

export enum ListView {
  ALL = 'All',
  SELECTED = 'Selected',
}

export interface IAdjustmentsProps {
  aging?: string | number | null;
  columns: ITerm[];
  dataCut: INode;
  job?: INode;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
  setMatchDataLoading?: ISetMatchDataLoading;
  surveyJob: INode;
  updateMatchesInState?: (updatedJob: INode) => void;
}

export interface IDataCutModifications {
  [key: string]: INode[];
}

export interface IDataCutsPreviewProps {
  item: { dataCuts: INode[], type: string };
}

export interface ISurveyJobPanelProps {
  checkedDataCuts: INode[];
  setCheckedDataCuts: (dataCuts: INode[]) => void;
}

export interface ISurveyJobProps {
  checkedDataCuts: (INode | ISelectedMatch)[];
  currency?: string;
  disableCheckbox?: (currentCut: INode) => boolean;
  isChecked: (currentCut: INode) => boolean;
  isFinalCard?: boolean;
  isSurveyPanel: boolean;
  job?: INode;
  onCheckDataCut: (currentCut: INode) => void;
  onDataCutListChange?: (dataCuts: INode[]) => void;
  setMatchDataLoading?: ISetMatchDataLoading;
  setOrgJobsDataStale?: (stale: boolean) => void;
  surveyJob: INode;
  updateMatchesInState?: (updatedJob: INode) => void;
  setCheckedDataCuts?: (dataCuts: INode[] | ((pending: INode[]) => INode[])) => void;
}
